module.exports = __webpack_public_path__ + "svg/OpenSans-CondLight-webfont.867a86.svg";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/assets/fonts/OpenSans-CondLight-webfont.svg
 ** module id = 320
 ** module chunks = 12
 **/